import './Header.css'
import React from 'react'
import {
    NavLink, Link
} from "react-router-dom";

function Header() {

    return (
        <div className="header">

            <Link className="logo" to="/"><h1>hs</h1></Link>

            <hr />

            <div className="header__info">
                <h4>Harshita Singh</h4>
                <p>Design & Development</p>
            </div>

            <hr />

            <h5>
                <NavLink className="header__link" exact activeClassName="active" to="/">WORK</NavLink>
                &nbsp;<span>/</span> &nbsp;
                <NavLink className="header__link" activeClassName="active" to="/about">ABOUT</NavLink>
            </h5>

        </div>
    )
}

export default Header